import "./scripts/furniture";
import "./scripts/zoom";
import "./scripts/filters";

import "./styles/product.scss";
import "./styles/products.scss";
